export enum DashboardJobStatus {
    Submitted = 0,
    Running = 1,
    Finished = 2,
    Deleted = 3,
    Invalid = 4
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/DashboardJobStatus.ts